import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  Drawer, 
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import logo from '../assets/Images/MainLogo.jpg';

const Navigation = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  
  // if i clcik on services button then i want to scroll to the services section like wise handle for others buttons also with one function

  const handleClick = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile drawer when navigation item is clicked
    setMobileOpen(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };



  return (
    <AppBar 
      position="static" 
      elevation={3}
      sx={{ 
        background: 'linear-gradient(135deg, #1a237e 0%,rgb(148, 101, 52) 100%)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        padding: { xs: '0 20px', sm: '0 40px', md: '0 80px' },
        backdropFilter: 'blur(10px)',
        position: 'sticky',
        top: 0,
        zIndex: 1100
      }}
    >
      <Toolbar 
        sx={{ 
          justifyContent: 'space-between', 
          padding: { xs: '16px 0', md: '20px 0' },
          flexWrap: 'wrap',
          maxWidth: '1400px',
          margin: '0 auto',
          width: '100%',
          position: 'relative'
        }}
      >
        {/* Logo on Left */}
        <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          transition: 'transform 0.3s ease',
          height: { xs: '50px', md: '60px' },
          flex: '0 0 auto',
          '&:hover': {
            transform: 'scale(1.02)'
          }
        }}>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              height: { xs: '45px', sm: '50px', md: '55px' },
              width: 'auto',
              objectFit: 'contain',
              display: 'block',
              maxHeight: '100%'
            }}
          />
        </Box>
        
        {/* Tamil Cars Text Centered in Remaining Space */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '16px', sm: '20px', md: '24px' },
              fontWeight: 'bold',
              color: 'white',
              fontFamily: 'Google Sans, sans-serif',
              background: 'linear-gradient(135deg, #ff6f00 0%, #ffb74d 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textShadow: '0 2px 4px rgba(0,0,0,0.1)',
              letterSpacing: { xs: '0.5px', md: '1px' },
              whiteSpace: 'nowrap'
            }}
          >
           தமிழ் கார்ஸ்
          </Typography>
        </Box>
        
        {/* Mobile Menu Button on Right */}
        <Box sx={{ 
          flex: '0 0 auto',
          display: { xs: 'flex', md: 'none' },
          alignItems: 'center'
        }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{ 
              color: 'white',
              padding: '8px'
            }}
          >
            <MenuIcon sx={{ fontSize: '28px' }} />
          </IconButton>
        </Box>

        {/* Desktop Navigation */}
        <Box sx={{ 
          display: { xs: 'none', md: 'flex' }, 
          gap: { xs: '16px', md: '24px', lg: '32px' }, 
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <Button 
            sx={{ 
              color: '#ff6f00', 
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: '16px',
              position: 'relative',
              padding: '8px 16px',
              borderRadius: '4px',
              transition: 'all 0.3s ease',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '4px',
                left: '16px',
                width: 'calc(100% - 32px)',
                height: '2px',
                backgroundColor: '#ff6f00',
                borderRadius: '2px'
              },
              '&:hover': {
                backgroundColor: 'rgba(255, 111, 0, 0.1)',
                transform: 'translateY(-2px)'
              }
            }}
            onClick={() => handleClick('home')}
          >
            Home
          </Button>
          <Button
            onClick={
              ()=>
                handleClick("services")
            }
            sx={{ 
              color: 'white', 
              textTransform: 'none',
              fontSize: '16px',
              padding: '8px 16px',
              borderRadius: '4px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateY(-2px)'
              }
            }}
          >
            Services
          </Button>
    
          <Button 
            sx={{ 
              color: 'white', 
              textTransform: 'none',
              fontSize: '16px',
              padding: '8px 16px',
              borderRadius: '4px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateY(-2px)'
              }
            }}

            onClick={
              ()=>{
                handleClick("about_us")
              }

            }

          >
            About us
          </Button>
          {/* <Button 
            sx={{ 
              color: 'white', 
              textTransform: 'none',
              fontSize: '16px',
              padding: '8px 16px',
              borderRadius: '4px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateY(-2px)'
              }
            }}
            onClick={
              ()=>{
                handleClick("blogs")
              }

            }
          >
            Blogs
          </Button> */}
          <Button 
            sx={{ 
              color: 'white', 
              textTransform: 'none',
              fontSize: '16px',
              padding: '8px 16px',
              borderRadius: '4px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateY(-2px)'
              }
            }}
            onClick={
              ()=>{
                handleClick("contact_us")
              }

            }
          >
            Contact us
          </Button>
          {/* <Button
            variant="contained"
            onClick={() => setBookingModalOpen(true)}
            sx={{
              background: 'linear-gradient(135deg, #ff6f00 0%, #ff8f00 100%)',
              color: 'white',
              borderRadius: '6px',
              padding: '10px 24px',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              boxShadow: '0 4px 12px rgba(255, 111, 0, 0.3)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, #ff8f00 0%, #ff6f00 100%)',
                boxShadow: '0 6px 20px rgba(255, 111, 0, 0.4)',
                transform: 'translateY(-2px)'
              }
            }}
          >
            Book Now
          </Button> */}
        </Box>
      </Toolbar>
      
      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: '100vw',
            background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
            color: 'white',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '24px 20px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          {/* Logo on Left */}
          <Box sx={{ 
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 auto'
          }}>
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                height: '50px',
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Tamil Cars Text Centered in Remaining Space */}
          <Box sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Typography
              variant="h5"
              sx={{
                fontSize: '22px',
                fontWeight: 'bold',
                color: 'white',
                fontFamily: 'Google Sans, sans-serif',
                background: 'linear-gradient(135deg, #ff6f00 0%, #ffb74d 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                letterSpacing: '1px'
              }}
            >
           தமிழ் கார்ஸ்
            </Typography>
          </Box>

          {/* Close Button on Right */}
          <Box sx={{ 
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center'
          }}>
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                color: 'white',
                padding: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              <CloseIcon sx={{ fontSize: '28px' }} />
            </IconButton>
          </Box>
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          height: 'calc(100vh - 100px)',
          justifyContent: 'space-between',
          padding: '20px 0'
        }}>
          <List sx={{ padding: '0', width: '100%' }}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleClick('home')}
                sx={{
                  padding: '20px 24px',
                  borderRadius: '12px',
                  margin: '8px 20px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 111, 0, 0.2)',
                    transform: 'translateX(8px)'
                  }
                }}
              >
                <ListItemText 
                  primary="Home" 
                  primaryTypographyProps={{
                    fontSize: '20px',
                    fontWeight: 600,
                    color: '#ff6f00'
                  }}
                />
              </ListItemButton>
            </ListItem>
            
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleClick('services')}
                sx={{
                  padding: '20px 24px',
                  borderRadius: '12px',
                  margin: '8px 20px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    transform: 'translateX(8px)'
                  }
                }}
              >
                <ListItemText 
                  primary="Services" 
                  primaryTypographyProps={{
                    fontSize: '20px',
                    fontWeight: 500,
                    color: 'white'
                  }}
                />
              </ListItemButton>
            </ListItem>
            
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleClick('about_us')}
                sx={{
                  padding: '20px 24px',
                  borderRadius: '12px',
                  margin: '8px 20px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    transform: 'translateX(8px)'
                  }
                }}
              >
                <ListItemText 
                  primary="About Us" 
                  primaryTypographyProps={{
                    fontSize: '20px',
                    fontWeight: 500,
                    color: 'white'
                  }}
                />
              </ListItemButton>
            </ListItem>
            
            {/* <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleClick('blogs')}
                sx={{
                  padding: '20px 24px',
                  borderRadius: '12px',
                  margin: '8px 20px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    transform: 'translateX(8px)'
                  }
                }}
              >
                <ListItemText 
                  primary="Blogs" 
                  primaryTypographyProps={{
                    fontSize: '20px',
                    fontWeight: 500,
                    color: 'white'
                  }}
                />
              </ListItemButton>
            </ListItem> */}
            
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleClick('contact_us')}
                sx={{
                  padding: '20px 24px',
                  borderRadius: '12px',
                  margin: '8px 20px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    transform: 'translateX(8px)'
                  }
                }}
              >
                <ListItemText 
                  primary="Contact us" 
                  primaryTypographyProps={{
                    fontSize: '20px',
                    fontWeight: 500,
                    color: 'white'
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
          
          <Box sx={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                // Scroll to booking section (BookingModal component)
                const bookingSection = document.querySelector('[data-booking-section]');
                if (bookingSection) {
                  bookingSection.scrollIntoView({ behavior: 'smooth' });
                }
                setMobileOpen(false);
              }}
              sx={{
                background: 'linear-gradient(135deg, #ff6f00 0%, #ff8f00 100%)',
                color: 'white',
                borderRadius: '12px',
                padding: '16px 24px',
                textTransform: 'none',
                fontSize: '18px',
                fontWeight: 'bold',
                boxShadow: '0 4px 12px rgba(255, 111, 0, 0.3)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'linear-gradient(135deg, #ff8f00 0%, #ff6f00 100%)',
                  boxShadow: '0 6px 20px rgba(255, 111, 0, 0.4)',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              Book Now
            </Button>
            
            <Button
              variant="outlined"
              fullWidth
              onClick={handleDrawerToggle}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                borderRadius: '12px',
                padding: '16px 24px',
                textTransform: 'none',
                fontSize: '18px',
                fontWeight: '600',
                borderWidth: '2px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderWidth: '2px',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navigation;
